<template>
    <div class="mt-3px">
        <span class="font-weight-bold text-dark">{{ $t(leftText) }}: </span>
        <slot></slot>
    </div>
</template>

<script>
/**
 * Soldaki metne göre sağı tanımlayan basit util
 */
export default {
    name: 'description',
    props: {
        leftText: { type: String, required: true },
    },
};
</script>
